export default __webpack_public_path__ + "static/media/arrow_right.c8d60c51.svg";